module.exports = __webpack_public_path__ + "img/adv_icon1.e252a864.png";